import WorldCultureAwareness1 from '../../images/games/world_culture_awareness/1.png';
import WorldCultureAwareness2 from '../../images/games/world_culture_awareness/2.png';
import WorldCultureAwareness3 from '../../images/games/world_culture_awareness/3.png';
import WorldCultureAwareness4 from '../../images/games/world_culture_awareness/4.png';
import WorldCultureAwareness5 from '../../images/games/world_culture_awareness/5.png';
import WorldCultureAwareness6 from '../../images/games/world_culture_awareness/6.png';
import WorldCultureAwareness7_1 from '../../images/games/world_culture_awareness/7_1.png';
import WorldCultureAwareness7_2 from '../../images/games/world_culture_awareness/7_2.png';
import WorldCultureAwareness8 from '../../images/games/world_culture_awareness/8.png';
import WorldCultureAwareness9 from '../../images/games/world_culture_awareness/9.png';
import WorldCultureAwareness10 from '../../images/games/world_culture_awareness/10.png';
import WorldCultureAwareness11 from '../../images/games/world_culture_awareness/11.png';
import WorldCultureAwareness12 from '../../images/games/world_culture_awareness/12.png';
import WorldCultureAwareness13 from '../../images/games/world_culture_awareness/13.png';
import WorldCultureAwareness14 from '../../images/games/world_culture_awareness/14.png';
import WorldCultureAwareness15 from '../../images/games/world_culture_awareness/15.png';
import WorldCultureAwareness16 from '../../images/games/world_culture_awareness/16.png';
import WorldCultureAwareness17 from '../../images/games/world_culture_awareness/17.png';
import WorldCultureAwareness18 from '../../images/games/world_culture_awareness/18.png';
import WorldCultureAwareness19 from '../../images/games/world_culture_awareness/19.png';
import WorldCultureAwareness20 from '../../images/games/world_culture_awareness/20.png';
import WorldCultureAwareness21 from '../../images/games/world_culture_awareness/21.png';
import WorldCultureAwareness22 from '../../images/games/world_culture_awareness/22.png';
import WorldCultureAwareness23 from '../../images/games/world_culture_awareness/23.png';
import WorldCultureAwareness24 from '../../images/games/world_culture_awareness/24.png';
import WorldCultureAwareness25 from '../../images/games/world_culture_awareness/25.png';
import CulturalAcceptanceImage from '../../images/games/world_culture_awareness/Cultural_Acceptance.jpg';


var questions = {
  '1': {
    'heading': 'DINING ETIQUETTE',
    'question': 'If you visit this country you should know that slurping your food shows your appreciation of the food to the chef. The louder the better! You may also drink directly from the soup bowl — spoons are uncommon. Which country is described above?',
    'options': ['Portugal', 'Algeria', 'Japan', 'Costa Rica'],
    'images': [WorldCultureAwareness1],
    'correct_index': 2,
    'explanation': ''
  },
  '2': {
    'heading': 'BUSINESS ETIQUETTE',
    'question': 'In most ____?____ countries, a business card is seen as an extension of the person it represents; therefore, to disrespect a card -- by folding it, writing on it, or just shoving it into your pocket without looking at it -- is to disrespect the person who gave it to you.',
    'options': ['European', 'South American', 'African', 'Asian'],
    'images': [WorldCultureAwareness2],
    'correct_index': 3,
    'explanation': ''
  },
  '3': {
    'heading': 'NON-VERBAL ETIQUETTE',
    'question': "Texas Long-Horn fans beware! The horns sign that fans use at UTexas games has a different meaning in Italy, Portugal, Spain and a few other Mediterranean countries. It's a sign",
    'options': ['of the devil.', 'to say to someone that their partner is cheating on them.', 'to say that someone is as strong as a bull.', 'to put a hex on someone.'],
    'images': [WorldCultureAwareness3],
    'correct_index': 1,
    'explanation': ''
  },
  '4': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "Spitting in ____________is a kind of good luck charm that is supposed to help ward off the devil. Today, the custom has evolved into a more symbolic act where guests mainly forcefully utter ‘ftou ftou ftou.’ This is also done at other special occasions such as weddings, baptisms…etc . Spitting can even be done as a superstitious measure to ward off evil during regular conversation.",
    'options': ['Belgium', 'Argentina', 'Japan', 'Greece'],
    'images': [WorldCultureAwareness4],
    'correct_index': 3,
    'explanation': ''
  },
  '5': {
    'heading': 'DINING & SOCIAL ETIQUETTE',
    'question': "If you visit a country with Islamic roots, or other places around the world including Middle East, Sri Lanka, India and parts of Africa, which hand should you use for eating, greeting, handling merchandise, exchanging money and other social activities? Using the wrong hand would be considered quite rude and insulting because these cultures use one of their hands for cleaning themselves after using the toilet, and, therefore, it is considered dirty.",
    'options': ['Right','Left'],
    'images': [WorldCultureAwareness5],
    'correct_index': 0,
    'explanation': ''
  },
  '6': {
    'heading': 'BUSINESS ETIQUETTE',
    'question': "A product demonstration with an Asian buyer is likely to be most effective if you…",
    'options': ['Show them a diagram','Let them try for themselves', 'Give them a manual to read', 'Orally explain its operations to them'],
    'images': [WorldCultureAwareness6],
    'correct_index': 0,
    'explanation': 'Asian languages are based on pictures. Because of this, people from these cultures tend to be more visual, preferring to look at pictures, charts, and graphs.'
  },
  '7': {
    'heading': 'NON-VERBAL ETIQUETTE',
    'question': "In which country is considered offensive to wink or to whistle in public?",
    'options': ['Argentina','Austria', 'Algeria', 'India'],
    'images': [WorldCultureAwareness7_1, WorldCultureAwareness7_2],
    'correct_index': 3,
    'explanation': ''
  },
  '8': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "In most of _____________ countries, when using the toilet, toilet paper is thrown into a trash can conveniently situated next to the potty. This is because most plumbing systems there are not equipped to break down the paper and flushing can lead to major septic backups.",
    'options': ['Latin American','Asian', 'African', 'European'],
    'images': [WorldCultureAwareness8],
    'correct_index': 0,
    'explanation': ''
  },
  '9': {
    'heading': 'DINING ETIQUETTE',
    'question': "When ordering a hot dog in South America, specially in Chile and Brazil, you should be prepared for it to be …",
    'options': ['Served without a bun, but still on a plate','Made from the meat of a guinea pig', 'Topped with corn, peas and mayonnaise'],
    'images': [WorldCultureAwareness9],
    'correct_index': 2,
    'explanation': 'In several South American countries, including Brazil and Chile, hot dogs and even pizza are normally eaten laden with toppings such as chopped veggies and many condiments. Ordering a hot dog plain, or with “just mustard,” is met with looks of confusion.'
  },
  '10': {
    'heading': 'BUSINESS ETIQUETTE',
    'question': "You have a very exciting business opportunity in China, and your boss is bringing you along. This is an important meeting and you want to get it right. Which of these would be an inappropriate thing to do in a Chinese company?",
    'options': ['Greeting the youngest person first','Using their honorific titles and last names', 'Shaking hands', 'Greeting the most senior business associate first'],
    'images': [WorldCultureAwareness10],
    'correct_index': 0,
    'explanation': ''
  },
  '11': {
    'heading': 'NON-VERBAL ETIQUETTE',
    'question': "In ____________ you should never touch anyone’s head, because it is considered the “seat of the soul” and is very offensive.",
    'options': ['Germany', 'India', 'Morocco', 'Canada'],
    'images': [WorldCultureAwareness11],
    'correct_index': 1,
    'explanation': ''
  },
  '12': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "You are in Africa and you need to get to a specific destination immediately. How should you communicate that to your fellow travelers?",
    'options': ['We need to leave now!', 'We need to leave now now!', 'We need to leave just now!'],
    'images': [WorldCultureAwareness12],
    'correct_index': 1,
    'explanation': 'In some parts of Africa, time is so fluid that it has three categories: now (an hour or more, no one really knows), just now (maybe an hour or less) and now now (if you are not in the vehicle at this moment, it will leave you in the dust).'
  },
  '13': {
    'heading': 'DINING ETIQUETTE',
    'question': "At a restaurant in Spain, you have finished your meal and you are ready to leave. You still have not received the check, however. Why?",
    'options': ['You didn’t eat all your food and your plate is not clean.', 'You are expected to settle your payment at the door.', 'You never asked for it.'],
    'images': [WorldCultureAwareness13],
    'correct_index': 2,
    'explanation': 'It is considered rude for the waiter to bring you the bill without asking. It is like saying that they want for you to leave.'
  },
  '14': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "In which country the “okay” sign means zero instead of OK?",
    'options': ['Germany', 'USA', 'France', 'China'],
    'images': [WorldCultureAwareness14],
    'correct_index': 2,
    'explanation': ''
  },
  '15': {
    'heading': 'DINING & SOCIAL ETIQUETTE',
    'question': "Where is tipping considered extremely offensive?",
    'options': ['Malaysia', 'Saudi Arabia', 'France', 'Japan'],
    'images': [WorldCultureAwareness15],
    'correct_index': 3,
    'explanation': ''
  },
  '16': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "In which part of the world should the soles of one’s feet never be shown?",
    'options': ['Europe', 'South America', 'Middle East', 'Asia'],
    'images': [WorldCultureAwareness16],
    'correct_index': 2,
    'explanation': ''
  },
  '17': {
    'heading': 'DINING ETIQUETTE',
    'question': "Where is it considered rude to finish all the food on one’s plate?",
    'options': ['Senegal', 'China', 'Finland', 'Chile'],
    'images': [WorldCultureAwareness17],
    'correct_index': 1,
    'explanation': 'China- If you finish all your food is a sign of you being still hungry '
  },
  '18': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "In __________, it is rude to sit in the back of a taxi if you’re travelling on your own. This comes down to “mateship”, (term for the culture of equality in this country). You can have a chat with anyone, even a stranger, and therefore be courteous and sit next to the guy doing you favor.",
    'options': ['Poland', 'Australia', 'Uruguay', 'Vietnam'],
    'images': [WorldCultureAwareness18],
    'correct_index': 1,
    'explanation': ''
  },
  '19': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "If you visit __________, and you put your hands in your pocket while speaking, you will be considered arrogant and rude.",
    'options': ['Canada & Bulgaria', 'Argentina & Libya', 'Turkey & South Korea', 'Cuba & Chile'],
    'images': [WorldCultureAwareness19],
    'correct_index': 2,
    'explanation': ''
  },
  '20': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "If you ever visit ____________ you should know that it is illegal to bring (and to chew) gum, and that you could get arrested for doing so. The only exceptions are dental or nicotine gum.",
    'options': ['Belgium','Panama', 'Spanish class', 'Singapore'],
    'images': [WorldCultureAwareness20],
    'correct_index': 3,
    'explanation': ''
  },
  '21': {
    'heading': 'SOCIAL ETIQUETTE',
    'question': "The number 4 is considered good luck in some countries, like Germany. However, in others it is bad luck, and they do not use it in elevators, hotels rooms...etc. Which one of the following is a country where number 4 is avoided?",
    'options': ['Japan', 'Argentina', 'The Netherlands', 'Israel'],
    'images': [WorldCultureAwareness21],
    'correct_index': 0,
    'explanation': 'Japan - the number 4 is pronounced as the words for death'
  },
  '22': {
    'heading': 'CULTURAL DIFFERENCES',
    'question': "In Colombia, Spain, and other Latino countries, schoolchildren learn that there are five continents, not seven.",
    'options': ['True', 'False'],
    'images': [WorldCultureAwareness22],
    'correct_index': 0,
    'explanation': ''
  },
  '23': {
    'heading': 'CULTURAL DIFFERENCES',
    'question': "Feeding birds in __________would cost you a fine of up to $700. The city banned the practice, citing the birds as a health hazard, and as bad for the monuments.",
    'options': ['Madrid','Beirut', 'Venice', 'Caracas'],
    'images': [WorldCultureAwareness23],
    'correct_index': 2,
    'explanation': ''
  },
  '24': {
    'heading': 'CULTURAL DIFFERENCES',
    'question': "Where would you be attending school if you see this way to do long division in your Math class?",
    'options': ['France, Romania, & Belgium','Italy, Lithuania, Greece & Iran', 'Portugal, Spain, Turkey and Russia', 'All of the above'],
    'images': [WorldCultureAwareness24],
    'correct_index': 3,
    'explanation': ''
  },
  '25': {
    'heading': 'CULTURAL DIFFERENCES',
    'question': "In Spain, going in public wearing only a bathing suit -- bikini or swim trunks -- is illegal in_______, and could result in a fine as well as lots of looks from offended locals. Make sure to cover up before you leave the beach!",
    'options': ['Barcelona', 'Madrid', 'Granada', 'Bilbao'],
    'images': [WorldCultureAwareness25],
    'correct_index': 0,
    'explanation': ''
  }
}

window.selectAnswer = function(e) {
  var question_id = e.getAttribute("data-question-id");
  $('.fa-mark').remove();
  $('input:radio').each(function() {
    if($(this).is(':checked') && $(this).val() != questions[question_id]['correct_index']) {
      $('<i class="fa-mark fa fa-close" style="font-size:24px;color:red"></i>').insertBefore($(this));
    } else if ($(this).is(':checked') || $(this).val() == questions[question_id]['correct_index']) {
      $('<i class="fa-mark fa fa-check" style="font-size:24px;color:green"></i>').insertBefore($(this));
    }
  });

  if (questions[question_id]['explanation'].length > 0) {
    $('#explanation').html('Explainer text: ' + questions[question_id]['explanation']);
  } else {
    $('#explanation').text('');
  }
}

window.next_question = function(e) {
  var next_question_id = parseInt(e.getAttribute("data-question-id")) + 1;
  $('#explanation').text('');
  if(next_question_id in questions) {
    show_question(next_question_id);
  } else {
    $('#question-heading').html('<em>The first step towards change is awareness. The second is acceptance.</em><br><br/>Nathaniel Branden<br/><br/>');
    $('#question-description').remove();
    $('#picDiv').replaceWith('<div>' + CulturalAcceptanceImage + '</div>');
    $('#answer-options').remove();
    $('#next_question_btn').remove();
  }
  return false;
}

function show_question(question_index) {

  if(questions[question_index]) {
    $("#question-heading").text(questions[question_index]['heading']);
    $("#question-description").text(questions[question_index]['question']);
    $("#question-img").attr('src', questions[question_index]['images'][0]);

    if(questions[question_index]['images'].length > 1) {
      $("#question-img-1").attr('src', questions[question_index]['images'][1]);
    } else {
      $("#question-img-1").attr('src', '');
    }

    var answer_container = $('#answer-options');
    answer_container.html('');
    for (var i = 0; i < questions[question_index]['options'].length; i++) {
        answer_container.append('<div class="d-flex align-items-center"><input type="radio" name="answer_options" onClick="selectAnswer(this)" data-question-id="' + question_index + '" value="' + i + '"><label class="radio text-left">'+questions[question_index]['options'][i]+'</label></div>');
    }

    $('#next_question_btn').attr('data-question-id', question_index);
  }
};

$('input[name="answer_options"]').on('click', function() {
  alert('sample');
});

jQuery(function() {
  $(".world-culture-awareness").on("click", "#dirPlay", function() {
    $("#mainDir").hide();
    show_question(1);
    $("#mainGame").show();
  });
})
